import axios from "axios";
import {MAIN_URL} from "./general-variables";

const axiosInstance=axios.create({
    baseURL:MAIN_URL
});

export default axiosInstance;
